
import { User } from "@supabase/supabase-js";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import ProtectedRoutes from "./ProtectedRoutes";
import { Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import { useState, useEffect } from "react";
import LoadingSpinner from "@/components/common/LoadingSpinner";
import { logger } from "@/utils/logger";

interface AppRoutesProps {
  user: User | null;
  isLovableEditor: boolean;
}

export function AppRoutes({ user, isLovableEditor }: AppRoutesProps) {
  const [isInitializing, setIsInitializing] = useState(true);
  
  useEffect(() => {
    logger.debug('AppRoutes mounted with user:', user?.id);
    // Set a short timeout to ensure we don't show loading indefinitely
    const timer = setTimeout(() => {
      logger.debug('AppRoutes initialization complete');
      setIsInitializing(false);
    }, 500);
    
    return () => {
      logger.debug('AppRoutes unmounting, clearing timeout');
      clearTimeout(timer);
    };
  }, [user]);
  
  // Show initial loading state very briefly
  if (isInitializing && user === null && !isLovableEditor) {
    logger.debug('AppRoutes showing initial loading state');
    return <LoadingSpinner />;
  }
  
  logger.debug('AppRoutes rendering with user:', user?.id, 'isLovableEditor:', isLovableEditor);
  
  return (
    <div className="min-h-screen bg-background">
      <Routes>
        <Route 
          path="/login" 
          element={user ? <Navigate to="/" replace /> : <Login />} 
        />
        <Route 
          path="/auth/callback" 
          element={<AuthCallback />} 
        />
        <Route 
          path="/*" 
          element={
            <ProtectedRoutes user={user} />
          }
        />
      </Routes>
      <Toaster />
    </div>
  );
}
